module.exports = __webpack_public_path__ + "a582553dcbbad2a4a0142ab916b5fb2e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/linkedin-icon.svg
 ** module id = 209
 ** module chunks = 0
 **/